import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  isApp: false,
  device: "",
  connect: false,
  bridge: {},
  appVer : "",
  serverAppVer : "",
  langTyCode : "",
  fidoYn: '',
  authYn: '',
  useBioAuth: false,
}

const mutations = {
  connect(state, [device, appVersion]) {
    console.log('connect');
    state.isApp = device === 'and' || device === 'ios';
    state.device = device;
    if(appVersion) {
      state.appVer = appVersion;
    }

    if (state.device === "and" && window.emartApp && state.isApp) {
      state.connect = true
      state.bridge = window.emartApp;
    } else if (state.device === "ios" && window.webkit && state.isApp) {
      state.connect = true
      state.bridge = window.webkit.messageHandlers.emartApp;
    } else {
      console.log('모바일앱이 아닙니다.')
    }
  },
  init(state) {
    state.fidoYn = '';
    state.authYn = '';
    state.useBioAuth = false;
  },
}

const actions = {
  /**
   * 이마티콘 생체인증 설정여부 조회
   */
  async getFidoYn({ commit, state }) {
    if (state.bridge) {
      // await commit("init");

      if (state.device === 'and') {
        // alert("1. and getFidoYn Call");

        emartApp['getFidoYn']("window.getFidoYnCallBack");
      } else if (state.device === 'ios') {
        // alert("1. ios getFidoYn Call");

        // commit("connect", ['ios']);

        const message = {scheme: 'getFidoYn', callback: 'window.getFidoYnCallBack'};

        state.bridge.postMessage(message);
      }
    }
  },

  /**
   * 이마티콘 생체인증 설정 및 인증 성공 여부 조회
   */
  async useFidoYn({ commit, state }, data) {
    if(state.bridge) {
      state.authYn = '';

      if (state.fidoYn === 'Y') {
        state.useBioAuth = true; // 네이티브 생체인증 재호출 방지 처리.

        if (state.device === 'and') {
          // alert("1. and useFidoYn Call");

          emartApp['useFidoYn'](data.barcodeNo, "window.useFidoYnCallBack");
        } else if (state.device === 'ios') {
          // alert("1. ios useFidoYn Call");

          const message = {scheme: 'useFidoYn', barcodeNo: data.barcodeNo.toString(), callback: 'window.useFidoYnCallBack'};

          state.bridge.postMessage(message);
        }
      }
    }
  },
}

const nativeStore = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default nativeStore;
